export const BUSINESS_UNIT_FIELD = {
  TEN: {
    field: "ten",
    type: "text",
  },
  INVOICE_TEMPLATE_CODE: {
    field: "invoice_template_code",
    type: "text",
  },
  MST: {
    field: "mst",
    type: "text",
  },
  SERIAL: {
    field: "serial",
    type: "text",
  },
  DCHI: {
    field: "dchi",
    type: "text",
  },
  SOHD: {
    field: "soHd",
    type: "text",
  },
  SDTHOAI: {
    field: "sdthoai",
    type: "text",
  },
  FAX: {
    field: "fax",
    type: "text",
  },
  STKNHANG: {
    field: "stknhang",
    type: "text",
  },
  TNHANG: {
    field: "tnhang",
    type: "text",
  },
};

export const CUSTOMER_FIELD = {
  TEN: {
    field: "ten",
    type: "text",
  },
  MA: {
    field: "ma",
    type: "text",
  },
  CTY: {
    field: "cty",
    type: "text",
  },
  MST: {
    field: "mst",
    type: "text",
  },
  DCHI: {
    field: "dchi",
    type: "text",
  },
  STKNHANG: {
    field: "stknhang",
    type: "text",
  },
  TNHANG: {
    field: "tnhang",
    type: "text",
  },
  MAIL_TO: {
    field: "mail_to",
    type: "text",
  },
  SDTHOAI: {
    field: "sdthoai",
    type: "text",
  },
  PAYMENT_METHOD_CODE: {
    field: "payment_method_code",
    type: "text",
  },
  CURRENCY_CODE: {
    field: "currency_code",
    type: "text",
  },
};

export const TOTAL_PAYMENT_FIELD = {
  SUB_TOTAL: {
    field: "sub_total",
    type: "number",
  },
  TAX_TOTAL: {
    field: "tax_total",
    type: "number",
  },
  PAYMENT_TOTAL: {
    field: "payment_total",
    type: "number",
  },
  PAYMENT_TOTAL_TEXT: {
    field: "payment_total_text",
    type: "text",
  },
};

export const ITEMS_FIELD = {
  ITEM_NAME: {
    field: "item_name",
    type: "text",
  },
  UNIT: {
    field: "unit",
    type: "text",
  },
  QUATITY: {
    field: "quatity",
    type: "text",
  },
  PRICE: {
    field: "price",
    type: "number",
  },
  TAX_PERCENT: {
    field: "tax_percent",
    type: "text",
  },
  AMOUNT: {
    field: "amount",
    type: "number",
  },
};
